const IconMove = () => {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width={24} height={24} rx={3} fill="#EEE5FF" />
            <g clipPath="url(#clip0_10624_25018)">
                <path
                    d="M17.3334 10H6.66675V11.3333H17.3334V10ZM6.66675 14H17.3334V12.6667H6.66675V14Z"
                    fill="#7B67FB"
                />
            </g>
            <defs>
                <clipPath id="clip0_10624_25018">
                    <rect
                        width={16}
                        height={16}
                        fill="white"
                        transform="translate(4 4)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const IconMoveNoBg = () => (
    <svg
        width="12"
        height="4"
        viewBox="0 0 12 4"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.3332 0H0.666504V1.33333H11.3332V0ZM0.666504 4H11.3332V2.66667H0.666504V4Z"
            fill="#7B67FB"
        />
    </svg>
);

export default IconMove;
